import { useEffect, useState } from "react";
import DashboardLayout from "../../../../../layoutcontainers/DashboardLayout";
import { Card, FormControl, FormHelperText, Grid, Stack } from "@mui/material";
import MaterialTypography from "../../../../../components/MaterialTypography";
import MaterialButton from "../../../../../components/MaterialButton";
import MaterialInput from "../../../../../components/MaterialInput";
import MaterialSelect from "../../../../../components/MaterialSelect";
import MaterialBox from "../../../../../components/MaterialBox";
import FileSelector from "../../../../../components/fileSelector";
import {
  BASE_URL,
  fetchData,
  fetchDataById,
  postData,
  putData,
} from "../../../../Utils/Baseurl";

import { useLocation, useNavigate } from "react-router-dom";
import { useLoading } from "../../../../../context/loadingcontext";
import { useSnackbar } from "../../../../../components/SnackbarProvider";

const EmplyoeeAdd = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { showSnackbar } = useSnackbar();
  const [masterData, setMasterData] = useState({
    team: [],
    department: [],
    designation: [],
    role: [],
    manager: [],
  });
  const { setCirleLoading } = useLoading();
  const [pages, setPages] = useState({
    view: false,
    edit: false,
    id: "",
  });
  const [employeeData, setEmployeeData] = useState({
    employeeName: "",
    employeeEmail: "",
    employeeDept: "",
    employeeDesig: "",
    employeeRole: "",
    employeeId: "",
    employeeTeam: "",
    reportingManger: "",
    employeeProfile: "",
    employeeNameStatus: "unchecked",
    employeeEmailStatus: "unchecked",
    employeeDeptStatus: "unchecked",
    employeeRoleStatus: "unchecked",
    employeeDesigStatus: "unchecked",
    employeeIdStatus: "unchecked",
    reportingMangerStatus: "unchecked",
    employeeTeamStatus: "unchecked",
    employeeProfileStatus: "unchecked",
  });

  useEffect(() => {
    getDepartmentList();
    getDesignationList();
    getRoleList();
    getTeamList();
    getMangerList();
  }, []);
  useEffect(() => {
    const state = location.state;

    if (state) {
      if (state.type === "view") {
        setPages({ view: true, edit: false });
      } else if (state.type === "edit") {
        setPages({ view: false, edit: true });
      } else {
        setPages({ view: false, edit: false });
      }
      viewEmployee(state.data);
    } else {
      setPages({ view: false, edit: false });
    }
  }, [location]);

  //Get Department

  const getDepartmentList = async () => {
    try {
      const response = await fetchData("api/department/");

      if (response?.status && Array.isArray(response.data)) {
        setMasterData((pre) => ({
          ...pre,
          department: response.data,
        }));
      } else {
        setMasterData((pre) => ({
          ...pre,
          department: [],
        }));
      }
    } catch (error) {
      console.error("Error while fetching team list:", error);
      setMasterData((pre) => ({
        ...pre,
        department: [],
      }));
    }
  };

  //   Get Designation List

  const getDesignationList = async () => {
    try {
      const response = await fetchData("api/designation/");

      if (response?.status && Array.isArray(response.data)) {
        setMasterData((pre) => ({
          ...pre,
          designation: response.data,
        }));
      } else {
        setMasterData((pre) => ({
          ...pre,
          designation: [],
        }));
      }
    } catch (error) {
      console.error("Error while fetching team list:", error);
      setMasterData((pre) => ({
        ...pre,
        designation: [],
      }));
    }
  };

  //   Get Role List

  const getRoleList = async () => {
    try {
      const response = await fetchData("api/roles/");

      if (response?.status && Array.isArray(response.data)) {
        setMasterData((pre) => ({
          ...pre,
          role: response.data,
        }));
      } else {
        setMasterData((pre) => ({
          ...pre,
          role: [],
        }));
      }
    } catch (error) {
      console.error("Error while fetching role list:", error);
      setMasterData((pre) => ({
        ...pre,
        role: [],
      }));
    }
  };
  //   Get Manger List

  const getMangerList = async () => {
    try {
      const response = await fetchData("api/create_user/");

      if (response?.status && Array.isArray(response.data)) {
        setMasterData((pre) => ({
          ...pre,
          manager: response.data,
        }));
      } else {
        setMasterData((pre) => ({
          ...pre,
          manager: [],
        }));
      }
    } catch (error) {
      console.error("Error while fetching role list:", error);
      setMasterData((pre) => ({
        ...pre,
        manager: [],
      }));
    }
  };

  //   Get Team List

  const getTeamList = async () => {
    try {
      const response = await fetchData("api/teams/");

      if (response?.status && Array.isArray(response.data)) {
        setMasterData((pre) => ({
          ...pre,
          team: response.data,
        }));
      } else {
        setMasterData((pre) => ({
          ...pre,
          team: [],
        }));
      }
    } catch (error) {
      console.error("Error while fetching team list:", error);
      setMasterData((pre) => ({
        ...pre,
        team: [],
      }));
    }
  };
  //   Create or Update Emplyoee

  const createEmplyoee = async () => {
    setCirleLoading(true);
    let formdata = new FormData();
    formdata.append("email", employeeData?.employeeEmail);
    formdata.append("employee_code", employeeData?.employeeId);
    formdata.append("role_id", employeeData?.employeeRole?.value || null);
    formdata.append("employee_name", employeeData?.employeeName);
    formdata.append("department_id", employeeData?.employeeDept?.value || null);
    formdata.append(
      "designation_id",
      employeeData?.employeeDesig?.value || null
    );

    formdata.append(
      "reporting_manager_id",
      employeeData?.reportingManger?.value || null
    );

    formdata.append("team_id", employeeData?.employeeTeam?.value || null);
    if (employeeData?.employeeProfile?.name) {
      formdata.append("profile_image", employeeData?.employeeProfile);
    }
    try {
      let response;
      if (pages.edit) {
        response = await putData(
          `api/create_user/${location.state?.data}/`,
          formdata
        );
      } else {
        response = await postData("api/create_user/", formdata);
      }

      if (response.status) {
        showSnackbar(response?.message, "success");
        navigate("/employee-master");
      } else {
        showSnackbar(response?.message, "error");
      }
    } catch (error) {
      console.log(error);

      let message = "An unexpected error occurred";

      if (error?.response?.status === 400 && error?.response?.data?.message) {
        const errorData = error.response.data.message;

        if (typeof errorData === "object") {
          message = Object.entries(errorData)
            .map(([field, errors]) => `${field}: ${errors.join(", ")}`)
            .join("\n");
        } else {
          message = errorData;
        }
      } else if (error?.message) {
        message = error.message;
      }

      showSnackbar(message, "error");
    } finally {
      setCirleLoading(false);
    }
  };

  //  View Emplyoee
  const viewEmployee = async (row) => {
    setCirleLoading(true);
    try {
      const response = await fetchDataById(`api/create_user/${row}/`);

      if (response?.status && response.data) {
        const data = response.data;

        setEmployeeData((prev) => ({
          ...prev,
          employeeName: data.employee_name || "",
          employeeEmail: data.email || "",
          employeeId: data.employee_code || "",
          employeeDept: {
            value: data?.department?.id || null,
            label: data?.department?.department_name || "",
          },
          employeeDesig: {
            value: data?.designation?.id || null,
            label: data?.designation?.designation || "",
          },
          employeeRole: {
            value: data?.role?.id || null,
            label: data?.role?.role || "",
          },
          employeeTeam: {
            value: data?.team?.id || null,
            label: data?.team?.team_name || "",
          },
          reportingManger: {
            value: data?.reporting_manager?.id || null,
            label: data?.reporting_manager?.employee_name || "",
          },
          employeeProfile: data?.profile_image || null,
          employeeDeptStatus: "success",
          employeeDesigStatus: "success",
          employeeEmailStatus: "success",
          employeeIdStatus: "success",
          employeeNameStatus: "success",
          employeeProfileStatus: "success",
          employeeRoleStatus: "success",
          employeeTeamStatus: "success",
          reportingMangerStatus: "success",
        }));
      } else {
        console.warn("Unexpected response format:", response);
      }
    } catch (error) {
      console.error("Error fetching employee data:", error);
    } finally {
      setCirleLoading(false);
    }
  };

  // handle onchange function
  const handleChange = (event, selectEvent) => {
    let employeeState = { ...employeeData };
    if (event?.target === undefined && selectEvent) {
      if (selectEvent.name === "employeeDept") {
        const lengthRegex = new RegExp("^[A-Za-z0-9]");
        if (lengthRegex.test(event?.label) === true) {
          employeeState[selectEvent.name + "Status"] =
            event?.label === undefined ? "unchecked" : "success";
        } else {
          employeeState[selectEvent.name + "Status"] =
            selectEvent.value === "" ? "unchecked" : "error";
        }
      }
      if (selectEvent.name === "employeeDesig") {
        const lengthRegex = new RegExp("^[A-Za-z0-9]");
        if (lengthRegex.test(event?.label) === true) {
          employeeState[selectEvent.name + "Status"] =
            event?.label === undefined ? "unchecked" : "success";
        } else {
          employeeState[selectEvent.name + "Status"] =
            selectEvent.value === "" ? "unchecked" : "error";
        }
      }
      if (selectEvent.name === "employeeRole") {
        const lengthRegex = new RegExp("^[A-Za-z0-9]");
        if (lengthRegex.test(event?.label) === true) {
          employeeState[selectEvent.name + "Status"] =
            event?.label === undefined ? "unchecked" : "success";
        } else {
          employeeState[selectEvent.name + "Status"] =
            selectEvent.value === "" ? "unchecked" : "error";
        }
      }
      if (selectEvent.name === "reportingManger") {
        const lengthRegex = new RegExp("^[A-Za-z0-9]");
        if (lengthRegex.test(event?.label) === true) {
          employeeState[selectEvent.name + "Status"] =
            event?.label === undefined ? "unchecked" : "success";
        } else {
          employeeState[selectEvent.name + "Status"] =
            selectEvent.value === "" ? "unchecked" : "error";
        }
      }
      if (selectEvent.name === "employeeTeam") {
        const lengthRegex = new RegExp("^[A-Za-z0-9]");
        if (lengthRegex.test(event?.label) === true) {
          employeeState[selectEvent.name + "Status"] =
            event?.label === undefined ? "unchecked" : "success";
        } else {
          employeeState[selectEvent.name + "Status"] =
            selectEvent.value === "" ? "unchecked" : "error";
        }
      }
      employeeState[selectEvent.name] = event;
    } else {
      switch (event.target.name) {
        case "employeeName":
          {
            const alphaNLengthRegex = new RegExp("^([a-zA-Z ]{1,20})$");

            if (alphaNLengthRegex.test(event.target.value?.trim())) {
              employeeState[event.target.name + "Status"] = "success";
            } else {
              employeeState[event.target.name + "Status"] =
                event.target.value === "" ? "unchecked" : "error";
            }
          }
          break;
        case "employeeEmail":
          {
            const emailRegex = new RegExp(/^[\w.-]+@[\w-]+\.(com|in|yahoo)$/g);

            if (emailRegex.test(event.target.value?.trim())) {
              employeeState[event.target.name + "Status"] = "success";
            } else {
              employeeState[event.target.name + "Status"] =
                event.target.value === "" ? "unchecked" : "error";
            }
          }
          break;
        case "employeeId":
          {
            const alphaNumberLengthRegex = new RegExp("^([A-Za-z0-9 ]{3,15})$");

            if (alphaNumberLengthRegex.test(event.target.value?.trim())) {
              employeeState[event.target.name + "Status"] = "success";
            } else {
              employeeState[event.target.name + "Status"] =
                event.target.value === "" ? "unchecked" : "error";
            }
          }
          break;
        default:
          break;
      }
      employeeState[event.target.name] = event.target.value;
    }

    setEmployeeData(employeeState);
  };
  // handle file upload function
  const handleFileSelect = (file) => {
    setEmployeeData((pre) => ({
      ...pre,
      employeeProfile: file,
      employeeProfileStatus: "success",
    }));
  };

  // handle disabled function
  const disabledFunction = () => {
    let disabled;

    if (
      employeeData.employeeNameStatus === "success" &&
      employeeData?.employeeEmailStatus === "success" &&
      employeeData?.employeeIdStatus === "success" &&
      employeeData?.employeeDeptStatus === "success" &&
      employeeData?.employeeDesigStatus === "success" &&
      // employeeData?.employeeProfileStatus === "success" &&
      employeeData?.employeeRoleStatus === "success" &&
      employeeData?.employeeTeamStatus === "success" &&
      employeeData?.reportingMangerStatus === "success"
    ) {
      disabled = false;
    } else {
      disabled = true;
    }
    return disabled;
  };

  // handel cancel function
  const cancelFunction = () => {
    navigate("/employee-master");
  };

  return (
    <DashboardLayout>
      <Card>
        <MaterialBox sx={{ p: 2 }}>
          <Stack
            direction="row"
            justifyContent="space-between"
            alignItems="center"
            spacing={2}
            p={1}
            mb={2}
          >
            <Stack direction="column" spacing={0}>
              <MaterialTypography variant="h5" fontWeight="medium" color="dark">
                {pages.view
                  ? "View Employee"
                  : pages.edit
                  ? "Edit Emplyoee"
                  : "Add Employee"}
              </MaterialTypography>
              <MaterialTypography variant="caption" color="text">
                You can add the employee here.
              </MaterialTypography>
            </Stack>
          </Stack>
          <Grid container spacing={2}>
            <Grid size={{ xs: 12, md: 4 }}>
              <Stack direction="column" spacing={1}>
                <MaterialTypography variant="caption" color="text">
                  Employee Name <span style={{ color: "red" }}>*</span>
                </MaterialTypography>
                <MaterialInput
                  name="employeeName"
                  placeholder="Enter Employee Name"
                  value={employeeData.employeeName}
                  onChange={handleChange}
                  error={employeeData.employeeNameStatus === "error"}
                  success={employeeData.employeeNameStatus === "success"}
                  disabled={pages.view}
                />
                {employeeData.employeeNameStatus === "error" && (
                  <FormControl error style={{ marginTop: "0px" }}>
                    <FormHelperText>
                      The employee name should contains only alphabets.
                    </FormHelperText>
                  </FormControl>
                )}
              </Stack>
            </Grid>
            <Grid size={{ xs: 12, md: 4 }}>
              <Stack direction="column" spacing={1}>
                <MaterialTypography variant="caption" color="text">
                  Employee Mail <span style={{ color: "red" }}>*</span>
                </MaterialTypography>
                <MaterialInput
                  name="employeeEmail"
                  placeholder="Enter Employee Mail"
                  value={employeeData.employeeEmail}
                  onChange={handleChange}
                  error={employeeData.employeeEmailStatus === "error"}
                  success={employeeData.employeeEmailStatus === "success"}
                  disabled={pages.view}
                />
                {employeeData.employeeEmailStatus === "error" && (
                  <FormControl error style={{ marginTop: "0px" }}>
                    <FormHelperText>
                      Enter the valid mail address.
                    </FormHelperText>
                  </FormControl>
                )}
              </Stack>
            </Grid>
            <Grid size={{ xs: 12, md: 4 }}>
              <Stack direction="column" spacing={1}>
                <MaterialTypography variant="caption" color="text">
                  Employee Id <span style={{ color: "red" }}>*</span>
                </MaterialTypography>
                <MaterialInput
                  name="employeeId"
                  placeholder="Enter Employee Id"
                  value={employeeData.employeeId}
                  onChange={handleChange}
                  error={employeeData.employeeIdStatus === "error"}
                  success={employeeData.employeeIdStatus === "success"}
                  disabled={pages.view}
                />
                {employeeData.employeeIdStatus === "error" && (
                  <FormControl error style={{ marginTop: "0px" }}>
                    <FormHelperText>
                      Enter the valid Employee Id.
                    </FormHelperText>
                  </FormControl>
                )}
              </Stack>
            </Grid>
            <Grid size={{ xs: 12, md: 4 }}>
              <Stack direction="column" spacing={1}>
                <MaterialTypography variant="caption" color="text">
                  Employee Department <span style={{ color: "red" }}>*</span>
                </MaterialTypography>
                <MaterialSelect
                  name="employeeDept"
                  value={employeeData.employeeDept}
                  onChange={handleChange}
                  options={masterData?.department?.map((value) => {
                    return {
                      value: value.id,
                      label: value.department_name,
                    };
                  })}
                  error={employeeData.employeeDeptStatus === "error"}
                  success={employeeData.employeeDeptStatus === "success"}
                  isDisabled={pages.view}
                />
              </Stack>
            </Grid>
            <Grid size={{ xs: 12, md: 4 }}>
              <Stack direction="column" spacing={1}>
                <MaterialTypography variant="caption" color="text">
                  Employee Designation <span style={{ color: "red" }}>*</span>
                </MaterialTypography>
                <MaterialSelect
                  name="employeeDesig"
                  value={employeeData.employeeDesig}
                  onChange={handleChange}
                  options={masterData?.designation?.map((value) => {
                    return {
                      value: value.id,
                      label: value.designation,
                    };
                  })}
                  error={employeeData.employeeDesigStatus === "error"}
                  success={employeeData.employeeDesigStatus === "success"}
                  isDisabled={pages.view}
                />
              </Stack>
            </Grid>
            <Grid size={{ xs: 12, md: 4 }}>
              <Stack direction="column" spacing={1}>
                <MaterialTypography variant="caption" color="text">
                  Employee Role <span style={{ color: "red" }}>*</span>
                </MaterialTypography>
                <MaterialSelect
                  name="employeeRole"
                  value={employeeData.employeeRole}
                  onChange={handleChange}
                  customStyles={{padding:1}}
                  options={masterData?.role?.map((value) => {
                    return {
                      value: value.id,
                      label: value.role,
                    };
                  })}
                  error={employeeData.employeeRoleStatus === "error"}
                  success={employeeData.employeeRoleStatus === "success"}
                  isDisabled={pages.view}
                />
              </Stack>
            </Grid>
            <Grid size={{ xs: 12, md: 4 }}>
              <Stack direction="column" spacing={1}>
                <MaterialTypography variant="caption" color="text">
                  Reporting Manger <span style={{ color: "red" }}>*</span>
                </MaterialTypography>
                <MaterialSelect
                  name="reportingManger"
                  value={employeeData.reportingManger}
                  onChange={handleChange}
                  options={masterData?.manager?.map((value) => {
                    return {
                      value: value.id,
                      label: value.employee_name,
                    };
                  })}
                  isDisabled={pages.view}
                  error={employeeData.reportingMangerStatus === "error"}
                  success={employeeData.reportingMangerStatus === "success"}
                />
              </Stack>
            </Grid>
            <Grid size={{ xs: 12, md: 4 }}>
              <Stack direction="column" spacing={1}>
                <MaterialTypography variant="caption" color="text">
                  Employee Team <span style={{ color: "red" }}>*</span>
                </MaterialTypography>
                <MaterialSelect
                  name="employeeTeam"
                  value={employeeData.employeeTeam}
                  onChange={handleChange}
                  options={masterData?.team?.map((value) => {
                    return {
                      value: value.id,
                      label: value.team_name,
                    };
                  })}
                  isDisabled={pages.view}
                  error={employeeData.employeeTeamStatus === "error"}
                  success={employeeData.employeeTeamStatus === "success"}
                />
              </Stack>
            </Grid>
            <Grid size={{ xs: 12, md: 4 }}>
              <Stack direction="column" spacing={1}>
                <MaterialTypography variant="caption" color="text">
                  Employee Profile 
                </MaterialTypography>
                <FileSelector
                  onFileSelect={handleFileSelect}
                  fileUrl={
                    employeeData?.employeeProfile instanceof File
                      ? URL.createObjectURL(employeeData.employeeProfile)
                      : employeeData?.employeeProfile
                      ? `${BASE_URL}${employeeData.employeeProfile}`
                      : null
                  }
                  disabled={pages.view}
                />
              </Stack>
            </Grid>
          </Grid>

          <MaterialBox
            display="flex"
            justifyContent={{ md: "flex-end" }}
            sx={{ mt: 3 }}
          >
            <MaterialButton
              variant="gradient"
              color="dark"
              style={{
                maxWidth: "100px",
                minWidth: "100px",
                marginRight: "10px",
              }}
              onClick={cancelFunction}
            >
              Cancel
            </MaterialButton>
            {!pages.view && (
              <MaterialButton
                variant="gradient"
                color="dark"
                style={{ maxWidth: "100px", minWidth: "100px" }}
                disabled={disabledFunction()}
                onClick={createEmplyoee}
              >
                {pages.edit ? "Edit" : "Submit"}
              </MaterialButton>
            )}
          </MaterialBox>
        </MaterialBox>
      </Card>
    </DashboardLayout>
  );
};

export default EmplyoeeAdd;
